const CAPACITY_DEFAULTS = Object.freeze({ limit_tokens: null, used_tokens: null, percent: null, source: 'unavailable' });

export function buildTokenLimitProjection({ usage, capacity }, formatters) {
  const projection = { ...CAPACITY_DEFAULTS, ...capacity };
  const { limit_tokens: limit, used_tokens: used, percent, source } = projection;
  const lines = (formatters?.formatUserContextCapacityLines?.(projection) ?? []);
  return {
    budgetTokenLimit: null,
    providerModelLimit: usage?.provider_model_limit ?? null,
    modelTokenLimit: limit,
    displayTokenLimit: limit,
    estimatedTokens: used,
    totalTokens: used,
    source,
    tokenLimitSource: 'model',
    windowPercent: percent,
    status: source,
    tokenLabel: lines[0],
    budgetLine: lines[1] ?? '',
  };
}
